const allRules = {
  isRequired: value => {
    const message = 'Dit veld is verplicht.'
    if (value === null || value === undefined) { return message }
    if (typeof value === 'string' && value.trim() === '') { return message }
    if (typeof value === 'object' && !(value.id || value.name)) { return message }
    return true
  },
  isPassword: value => {
    if (value === null || value === undefined) return 'Vul een wachtwoord in'
    if (value.length < 8) return 'Het nieuwe wachtwoord moet minimaal 8 tekens lang zijn'
    return true
  },
  isDate: value => {
    const message = 'Dit is geen geldige datum'
    if (typeof value !== 'string') { return message }
    const re = /^\d\d-\d\d-\d\d\d\d$/
    return re.test(value) ? true : message
  },
  isPostcode: value => {
    const message = 'Dit is geen geldige postcode'
    if (typeof value !== 'string') { return message }
    const re = /^\d\d\d\d ?[A-Z]{2}$/
    return re.test(value) ? true : message
  },
  isEmail: value => {
    const message = 'Dit is geen geldig emailadres'
    if (typeof value !== 'string') { return message }
    const re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
    return re.test(value) ? true : message
  },
  hasNoNumbers: value => {
    const message = 'Dit veld mag geen nummers bevatten'
    if (typeof value !== 'string') { return true }
    return (/\d/.test(value) ? message : true)
  }
}

function getRule (ruleName) {
  if (ruleName in allRules) { return allRules[ruleName] }
  return () => true
}

export default function (rules) {
  if (typeof rules === 'string') { return [getRule(rules)] }
  else if (Array.isArray(rules)) {
    return rules.map(rule => {
      if (typeof rule === 'function') { return rule }
      if (typeof rule === 'string') { return getRule(rule) }
    })
  }
  return []
}
